module.exports = __webpack_public_path__ + "static/media/jobert.84384363.jpg";